import React from 'react';
import { classnames } from 'Utils/classnames/classnames.utils';
import { ICONS } from 'Components/utils/icon/icons';
import { useResponsive } from 'Components/utils/responsive/ResponsiveContext';
import type { IconName } from 'Components/frameworks/icon/Icon';
import 'Components/frameworks/icon/Icon';
import { Spinner } from 'Components/frameworks/spinner/Spinner';
import { SpinnerLabel } from 'Components/frameworks/spinner/label/SpinnerLabel';
import { themes } from './AsyncLoader.themes';
type Props = {
  className?: string;
  label?: string;
  icon?: IconName;
  iconSize?: string;
  size?: 'small' | 'medium' | 'tiny';
  theme?: keyof typeof themes;
};
export const AsyncLoader = ({
  className,
  label,
  icon = ICONS.TRIDENT1,
  iconSize,
  size,
  theme = 'default',
  ...rest
}: Props) => {
  const { isAppMounted } = useResponsive();

  if (!isAppMounted) {
    return null;
  }

  const { thLabel, thRoot } = themes[theme];
  return (
    <div {...rest} className={classnames(thRoot, className)}>
      <Spinner iconName={icon} iconSize={iconSize} size={size} />
      <SpinnerLabel className={thLabel} label={label} />
    </div>
  );
};
